import type { ReactNode } from 'react'
import type { TFunction } from 'i18next'

export interface PreviewErrorHandlerProps {
  errorType: 'unsupported' | 'error' | 413
  fileType: string
  t: TFunction
  handleDownload: () => Promise<void> | undefined
}

export interface StyledFilePreviewProps {
  isImage: boolean
}

export interface FilePreviewProps {
  filePath: string
  fileName: string
  mimeType?: string
  fileType: string
  className?: string
  noPageHeader?: boolean
  storageId?: string
  errorType?: PreviewErrorHandlerProps['errorType']
}

export interface FileViewProps extends FilePreviewProps {
  pdf?: {
    fileName: string
    filePath: string
    mimeType: string | null
  } | null
  handleDownload: () => Promise<void> | undefined
}

export interface ErrorBoundaryProps {
  errorComponent: ReactNode
  children: ReactNode
}

export interface ErrorBoundaryState {
  error: boolean
}

export interface GlobalStyleProps {
  whiteColor: boolean
}

export interface UnsupportedComponentProps {
  fileType: string
}

export enum AllSupportedDocumentFormats {
  PDF = 'pdf',
  DOC = 'doc',
  DOCX = 'docx',
  MSG = 'msg',
}

export enum AllSupportedImageFormats {
  JPEG = 'jpeg',
  JPG = 'jpg',
  GIF = 'gif',
  PNG = 'png',
  APNG = 'apng',
  SVG = 'svg',
  BMP = 'bmp',
  ICO = 'ico',
  WEBP = 'webp',
}

export enum AllSupportedAudioFormats {
  MP3 = 'mp3',
  WAV = 'wav',
}

export enum AllSupportedVideoFormats {
  MP4 = 'mp4',
  WebM = 'webm',
}

export const AllSupportedFileFormats = {
  ...AllSupportedDocumentFormats,
  ...AllSupportedImageFormats,
  ...AllSupportedAudioFormats,
  ...AllSupportedVideoFormats,
}

export type AllSupportedFileFormats =
  | AllSupportedDocumentFormats
  | AllSupportedImageFormats
  | AllSupportedAudioFormats
  | AllSupportedVideoFormats
